import { Suspense, memo } from 'react';
import type { FC } from 'react';

import type { LoadingWrapperVariant } from './loadingWrapper/loadingWrapper';
import { LoadingWrapper } from './loadingWrapper/loadingWrapper';
import { withScrollRestoration } from './withScrollRestoration/withScrollRestoration';

export const Loader = (Component: FC, variant?: LoadingWrapperVariant) =>
  memo((props: any) => {
    const { restoreScroll = false, ...componentProps } = props;

    const WrappedComponent = restoreScroll
      ? withScrollRestoration(Component)
      : Component;

    return (
      <Suspense
        fallback={<LoadingWrapper isLoading variant={variant || 'full-page'} />}
      >
        <WrappedComponent {...componentProps} />
      </Suspense>
    );
  });
